import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Crown icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Crown } from '@sravni/design-system-icons'
 *
 * <Crown />
 * ```
 */
var Crown = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Crown", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M17.023 14H4.51c-.424 0-.774-.293-.774-.732V6.683c0-.586.579-.766 1.003-.327L7.696 8.44l2.545-3.22a.668.668 0 0 1 .99 0l2.546 3.22 2.993-2.083c.425-.439.966-.259.966.327v6.585c0 .426-.288.732-.713.732Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Crown };
//# sourceMappingURL=Crown.js.map
